import React from 'react';
import { apiHost } from '../../../config';
import { useStatsig } from '../hooks/useStatsig';
import { withCurrentReturnTo } from '../../utils/oauthReturnTo';
import Img from '../Img';
import styles from '../../pages/LoginPage/Login/login.scss';

const FacebookLoginV2 = ({ flow = 'login', buttonText = 'Sign In with Facebook', 'data-testid': dataTestId }) => {
    const { checkGate, featureGates } = useStatsig();
    const isCampaignDeepLinkEnabled = checkGate(featureGates.POWER_CAMPAIGN_DEEP_LINK);

    const onSubmitFacebook = () => {
        const initiateUrl = `${apiHost}/v3/oauth/facebook/initiate?platform=web&flow=${flow}`;
        window.location.href = isCampaignDeepLinkEnabled ? withCurrentReturnTo(initiateUrl) : initiateUrl;
    };

    return (
        <button
            type="button"
            className={`btn btn-primary btn-block mb16 btn-xl`}
            onClick={onSubmitFacebook}
            data-testid={dataTestId || undefined}
        >
            <div className={`d-flex jcc align-items-center ${styles.facebookLogin} fw600`}>
                <Img src="/img/social/facebook-icon.svg" />
                <div className="ml-2 text-uppercase" data-testid={dataTestId && `${dataTestId}.text`}>{buttonText}</div>
            </div>
        </button>
    );
};

export default FacebookLoginV2;
